import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-offer-me-tour-card',
  templateUrl: './offer-me-tour-card.component.html',
  styleUrls: ['./offer-me-tour-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferMeTourCardComponent { }
